import { createFileRoute } from '@tanstack/react-router';

import { AdminWeatherPage } from '@/components/admin/weather-page';
import { adminHead } from '@/lib/seo';
import { adminListWeatherFn } from '@/server/functions/admin';

export const Route = createFileRoute('/_admin/admin/weather')({
    component: WeatherRoute,
    head: () => adminHead('מזג אוויר', '/admin/weather'),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: () => adminListWeatherFn(),
});

function WeatherRoute() {
    const data = Route.useLoaderData();
    return <AdminWeatherPage initial={data} />;
}
